module.exports = __webpack_public_path__ + "static/img/user.383d3a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/user.svg
// module id = 601
// module chunks = 180